import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import * as PurchaseActions from './actions';

import PurchasePage from './PurchasePage';

const PurchasePageContainer = ({
  dispatch,
  accounts,
  contracts,
  transactions,
  transactionStack,
  userId
}) => {
  const pathname = useLocation().pathname;
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.TkgGoldBuyingAndSelling;

  const [ dataKey, setDataKey ] = useState(null);
  const [ wills, setWills ] = useState(null);
  const [ fetched, setFetched ] = useState(false);
  const now = Date.now();
  const nowLowerBound = new Date(now - 60*60*24*7*1000);
  const nowUpperBound = new Date(now + 60*60*24*7*1000);
  const [ data, setData ] = useState({ startTime: nowLowerBound, endTime: nowUpperBound });

  const [ owner, setOwner ] = useState("OWNER");
  const [ open, setOpen ] = useState(false);
  const [ isInvalid, setIsInvalid ] = useState(false);

  const [ doModal, setDoModal ] = useState({
      does: false,
      userAddr: null,
      userId: null,
      amount: null,
      priceForToken: null,
      indicatedTime: null
    });
  const [ doModalOthers, setDoModalOthers ] = useState({
      does: false,
      userAddr: null,
      userId: null,
      amount: null,
      priceForToken: null,
      indicatedTime: null
    });
  const MINE = "MY INTENTS";
  const OTHERS = "OTHERS";

  const [ dataKeyR, setDataKeyR ] = useState(null);
  const [ dataKeyC, setDataKeyC ] = useState(null);
  const [ dataAD, setDataAD ] = useState({ dealAmount: null });
  const [ stackLen, setStackLen ] = useState(0);
  const [ rStackId, setRStackId ] = useState(0);
  const [ cStackId, setCStackId ] = useState(0);
  const [ doRevoke, setDoRevoke ] = useState(false);
  const [ doConfirm, setDoConfirm ] = useState(false);

  useEffect(() => {
    if (wills === null)
      return;

    initWill();
  }, [wills]);

  useEffect(() => {
    showWills(data.startTime, data.endTime);
  }, [pathname]);

  useEffect(() => {
    if (dataKey === null)
      return;
   
    fetchWills(dataKey, owner);
  }, [contracts.TkgGoldBuyingAndSelling.collectInfoOfWill, dataKey, owner]);

  useEffect(() => {
    if (doConfirm && (parseInt(dataAD.dealAmount) > parseInt(doModalOthers.amount) || dataAD.dealAmount === null)) {
      setDoConfirm(false);
      setIsInvalid(true);
      return;
    }

    if (!doConfirm || doModalOthers.amount === null)
      return;

    confirmsDeal(doModalOthers);
    dispatch(notifyDoPurchaseDeal(true));
  }, [doConfirm, doModalOthers, dataAD]);

  useEffect(() => {
    var txHash = 0;
    const length = transactionStack.length;
    if (length === stackLen)
      return;

    if (doRevoke)
      txHash = transactionStack[rStackId];
    else if (doConfirm)
      txHash = transactionStack[cStackId];

    if (transactions[txHash] && transactions[txHash].status === 'pending' && transactions[txHash].confirmations.length === 0)
      setStackLen(length);
  }, [transactions]);

  useEffect(() => {
    var txHash = 0;
    const length = transactionStack.length;
    if (length === stackLen)
      return;

    if (doRevoke)
      txHash = transactionStack[rStackId];
    else if (doConfirm)
      txHash = transactionStack[cStackId];

    if (transactions[txHash] && transactions[txHash].status === 'pending' && transactions[txHash].confirmations.length === 0)
      setStackLen(length);
  }, [transactions]);

  useEffect(() => {
    if (transactionStack.length === 0)
      return;

    var txHash = 0;

    if (doRevoke)
      txHash = transactionStack[rStackId];
    else if (doConfirm)
      txHash = transactionStack[cStackId];

    if (doRevoke && transactionStack.length > 0 && transactions[txHash].status === 'success') {
      setDoRevoke(false);
      setFetched(false);
      showWills(data.startTime, data.endTime);
      setDoModal({
        does: false,
        userAddr: null,
        amount: null,
        priceForToken: null,
        indicatedTime: null
      });
      dispatch(notifyDoPurchaseDeal(false));
    } else if (doConfirm && transactionStack.length > 0 && transactions[txHash].status === 'success') {
      setDoConfirm(false);
      setFetched(false);
      showWills(data.startTime, data.endTime);
      setDoModalOthers({
        does: false,
        userAddr: null,
        userId: null,
        amount: null,
        priceForToken: null,
        indicatedTime: null
      });
      setDataAD({ dealAmount: null });
      dispatch(notifyDoPurchaseDeal(false));
    }
  }, [transactions]);

  const decToHex =str => {
    var dec = str.toString().split(''),
      sum = [],
      hex = [],
      i,
      s;
    while (dec.length) {
      s = 1 * dec.shift();
      for (i = 0; s || i < sum.length; i++) {
        s += (sum[i] || 0) * 10;
        sum[i] = s % 16;
        s = (s - sum[i]) / 16;
      }
    }
    while (sum.length) {
      hex.push(sum.pop().toString(16));
    }
    return "0x" + hex.join('');
  }

  const initWill = () => {
    setFetched(true);
  }

  const showWills = async (_startTime, _endTime) => {
    if (_startTime === null || _endTime === null)
      return;

    const unixStartTime = Date.parse(_startTime) / 1000;
    const unixEndTime = Date.parse(_endTime) / 1000;

    var _dataKey = await contract.methods.collectInfoOfWill.cacheCall(unixStartTime, unixEndTime)
    setDataKey(_dataKey);
  }

  const fetchWills = (_dataKey, _owner) => {
    var i = 0;
    var j = 0;
    var _wills = [];
    var res = [];
    const SELL = 2;
    const MINE = "MY INTENTS";
    const OTHERS = "OTHERS";

    res = contracts.TkgGoldBuyingAndSelling.collectInfoOfWill[_dataKey]
      ? contracts.TkgGoldBuyingAndSelling.collectInfoOfWill[_dataKey].value
      : [];

    for (i = 0; i < res.length; i++) {
      if (parseInt(res[i].indicatedTime) > 0 && parseInt(res[i].dealType) === SELL && _owner === MINE && decToHex(res[i].userId) === userId)
        _wills[j++] = res[i];
      else if (parseInt(res[i].indicatedTime) > 0 && parseInt(res[i].dealType) === SELL && _owner === OTHERS && decToHex(res[i].userId) !== userId) {
        _wills[j++] = res[i];
      }
    }

    if (_wills.length > 0) {
      _wills = _wills.sort((a, b) => {
        return (a.indicatedTime < b.indicatedTime ? 1 : -1);
      });
      setWills(_wills);
    } else
      setWills(_wills);

    setFetched(false);

    return true;
  }

  const revokesWill = async _doModal => {
    const DEALTYPE = 2;

    const estimatedGas = await contract.methods.revokeWill(
      userId, _doModal.amount, _doModal.priceForToken, _doModal.indicatedTime, DEALTYPE
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const gasMultiplication = 1.2;
    const gasPriceMultiplication = 1.2;

    const _stackId = await contract.methods.revokeWill.cacheSend(
      userId, _doModal.amount, _doModal.priceForToken, _doModal.indicatedTime, DEALTYPE, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*gasMultiplication),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication)
    });

    dispatch(notifyDoPurchaseDeal(true));
    setDoRevoke(true);
    setRStackId(_stackId);
  }

  const confirmsDeal = async _doModal => {
    const DEALTYPE = 2;

    const estimatedGas = await contract.methods.indicateIntent(
      userId, _doModal.userId, _doModal.amount, _doModal.priceForToken, _doModal.indicatedTime, DEALTYPE, dataAD.dealAmount
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const gasMultiplication = 1.2;
    const gasPriceMultiplication = 1.2;

    const _stackId = await contract.methods.indicateIntent.cacheSend(
      userId, _doModal.userId, _doModal.amount, _doModal.priceForToken, _doModal.indicatedTime, DEALTYPE, dataAD.dealAmount, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*gasMultiplication),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication)
    });

    setDoConfirm(true);
    setIsInvalid(false);
    setCStackId(_stackId);
  }

  const onClickEle = i => {
    setOwner(i);
    setOpen(!open);
  }

  const onClickDropdown = e => {
    setOpen(!open);
  }

  const onClickForManipulation = (_owner, _userAddr, _userId, _amount, _priceForToken, _indicatedTime) => {
    if (_owner === MINE) 
      setDoModal({
        does: true,
        userAddr: _userAddr,
        userId: null,
        amount: _amount,
        priceForToken: _priceForToken,
        indicatedTime: _indicatedTime
      });
    else if (_owner = OTHERS) {
      setDoModalOthers({
        does: true,
        userAddr: _userAddr,
        userId: _userId,
        amount: _amount,
        priceForToken: _priceForToken,
        indicatedTime: _indicatedTime
      });
      setDataAD({ dealAmount: null });
      setDoConfirm(false);
    }
  }

  const willModalConfirm = (_owner, _doModal) => {
    if (_owner === MINE) {
      revokesWill(_doModal);
      setDoRevoke(true);
    } else if (_owner === OTHERS) {
      setDoConfirm(true);
    }
  }

  const willModalCancel = _owner => {
    if (_owner === MINE)
      setDoModal({
        does: false,
        userAddr: null,
        amount: null,
        priceForToken: null,
        indicatedTime: null
      });
    else if (_owner === OTHERS) {
      setDoModalOthers({
        does: false,
        userAddr: null,
        amount: null,
        priceForToken: null,
        indicatedTime: null
      });
      setDataAD({ dealAmount: null });
      setDoConfirm(false);
      setIsInvalid(false);
    }
  }

  const handleChangeAD = e => {
    setDataAD({...dataAD, [e.target.name]: e.target.value});
  };

  if (fetched)
    return (
      <PurchasePage
        wills={wills}
        owner={owner}
        open={open}
        doModal={doModal}
        doModalOthers={doModalOthers}
        isInvalid={isInvalid}
        onClickEle={onClickEle}
        onClickDropdown={onClickDropdown}
        onClickForManipulation={onClickForManipulation}
        handleChangeAD={handleChangeAD}
        willModalConfirm={willModalConfirm}
        willModalCancel={willModalCancel}
      />
    );
  else
    return (
      <div className="atom-spinner">
        <div className="spinner-inner">
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-circle">
            &#9679;
          </div>
        </div>
       </div>
    );
}

const notifyDoPurchaseDeal = doingPurchaseDeal => {
  return {
    type: PurchaseActions.COMMITTED_PURCHASE_DEAL,
    doingPurchaseDeal: doingPurchaseDeal,
  }
}

const mapStateToProps = state => ({
  accounts: state.accounts,
  contracts: state.contracts,
  transactions: state.transactions,
  transactionStack: state.transactionStack,
  contracts: state.contracts,
  accounts: state.accounts,
  userId: state.login.userId
});

export default connect(mapStateToProps)(PurchasePageContainer);
